<div
  class="min-h-screen flex flex-col bg-age-cream text-age-green font-segoe selection:bg-age-gold selection:text-white"
>
  <header class="flex justify-center pt-10 pb-6">
    <img src="logo.png" alt="AGE Logo" class="w-40 md:w-48 h-auto" />
  </header>
  <main class="flex-1 flex flex-col items-center px-4 pb-16">
    <div class="form-box">
      <div class="flex items-center justify-center relative mb-12">
        <button
          type="button"
          (click)="backPage()"
          class="absolute left-0 text-age-green hover:!text-age-gold transition-colors cursor-pointer"
        >
          <lib-arrow-left size="l"></lib-arrow-left>
        </button>

        <h1 class="font-bebas text-4xl text-age-green uppercase text-center">
          {{ title }}
        </h1>
      </div>

      <ng-content></ng-content>
    </div>
  </main>
  <lib-footer></lib-footer>
</div>
